import { defineMessages, useIntl } from 'react-intl';
import ButtonsWidget from '@plone/volto/components/manage/Widgets/ButtonsWidget';

import alignTopSVG from './icons/align-top.svg';
import alignBottomSVG from './icons/align-bottom.svg';
import alignMiddleSVG from './icons/align-vertical-middle.svg';
import alignCenterSVG from './icons/align-horizontal-middle.svg';
import alignLeftSVG from './icons/align-left.svg';
import alignRightSVG from './icons/align-right.svg';

const messages = defineMessages({
  left: {
    id: 'Align Left',
    defaultMessage: 'Left',
  },
  right: {
    id: 'Align Right',
    defaultMessage: 'Right',
  },
  center: {
    id: 'Align Center',
    defaultMessage: 'Center',
  },
  top: {
    id: 'Align Top',
    defaultMessage: 'Top',
  },
  bottom: {
    id: 'Align Bottom',
    defaultMessage: 'Bottom',
  },
});

const PositionWidget = (props) => {
  const intl = useIntl();

  const { direction = 'horizontal', default: defaultAction = 'center' } = props;

  const actions =
    direction === 'vertical'
      ? ['top', 'center', 'bottom']
      : ['left', 'center', 'right'];

  const actionsInfo =
    direction === 'vertical'
      ? {
          top: [alignTopSVG, intl.formatMessage(messages.top)],
          center: [alignMiddleSVG, intl.formatMessage(messages.center)],
          bottom: [alignBottomSVG, intl.formatMessage(messages.bottom)],
        }
      : {
          left: [alignLeftSVG, intl.formatMessage(messages.left)],
          center: [alignCenterSVG, intl.formatMessage(messages.center)],
          right: [alignRightSVG, intl.formatMessage(messages.right)],
        };

  return (
    <ButtonsWidget
      {...props}
      actions={actions}
      actionsInfoMap={actionsInfo}
      defaultAction={defaultAction}
    />
  );
};

export default PositionWidget;
